import React from 'react';

export default function MenuHamburguerIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke={stroke || "#414A53"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
